import type { ReactNode } from 'react';
import Breadcrumb, { type Crumb } from '@/components/feature/Breadcrumb';

interface PageHeaderProps {
  eyebrow: string;
  title: string;
  description: string;
  crumbs: Crumb[];
  image?: string;
  children?: ReactNode;
}

export default function PageHeader({ eyebrow, title, description, crumbs, image, children }: PageHeaderProps) {
  return (
    <section className="relative overflow-hidden border-b border-background-200/70 bg-background-100">
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" aria-hidden="true" className="h-full w-full object-cover object-top opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/85 to-background-50/40"></div>
        </div>
      )}
      <div className="relative w-full px-4 md:px-8 lg:px-12 py-10 md:py-16">
        <Breadcrumb items={crumbs} />
        <div className="mt-6 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3">
              <span className="h-px w-10 bg-primary-500"></span>
              <span className="font-label text-xs tracking-[0.32em] text-primary-400">{eyebrow}</span>
            </div>
            <h1 className="mt-3 font-heading text-2xl md:text-4xl font-bold leading-tight text-foreground-950">
              {title}
            </h1>
            <p className="mt-3 text-sm leading-relaxed text-foreground-400 md:text-base">{description}</p>
          </div>
          {children}
        </div>
      </div>
    </section>
  );
}